export default {"src":"/_next/static/media/embed.6ae14b48.svg","height":40,"width":40};